export const colors = {
  noImgCategory: 'baseColor.color7',
}

export const typeOfBanner = {
  link: 'Link',
  foodItem: 'FoodItem',
  foodCategory: 'FoodCategory',
  review: 'Review',
}

export const homeTemplate = {
  quilted: 1,
  list: 2,
  standard: 3,
}

export const DEFAULT_QUANTITY = 1
